import { render, staticRenderFns } from "./WorkflowWidget.vue?vue&type=template&id=5fac98e5&scoped=true"
import script from "./WorkflowWidget.vue?vue&type=script&lang=js"
export * from "./WorkflowWidget.vue?vue&type=script&lang=js"
import style0 from "./WorkflowWidget.vue?vue&type=style&index=0&id=5fac98e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fac98e5",
  null
  
)

export default component.exports